import { createContext } from 'react';

export interface AuthContextValue {
    isReady: boolean;
    isAuthenticated: boolean;
    username: string | null;
    email: string | null;
    token: string | null;
    error: unknown | null;
    login: (options?: { loginHint?: string }) => Promise<void>;
    register: (options?: { loginHint?: string }) => Promise<void>;
    logout: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextValue | null>(null);
